import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { PickupPlace } from './pickup-place.model';
import { PickupPlacesModalComponent } from '../components/pickup-places-modal/pickup-places-modal.component';
import { PickupPlaceTranslationModalComponent } from '../components/pickup-place-translation-modal/pickup-place-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class PickupPlaceModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openPickupPlacesModal(successCallback) {
    const options = {
      width: '900px',
      minHeight: '90vh',
      maxHeight: '90vh',
      disableClose: true,
      position: { top: '5vh' },
      data: {
        title: 'PICKUP_PLACES',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, PickupPlacesModalComponent);
  }

  openPickupPlaceTranslation(pickupPlace: PickupPlace, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'PICKUP_PLACE_DETAILS',
        obj: pickupPlace,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, PickupPlaceTranslationModalComponent);
  }
}
